var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7254_14743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 20.0492C7.5602 20.0492 3.9502 16.4392 3.9502 11.9992C3.9502 7.55922 7.5602 3.94922 12.0002 3.94922C16.4402 3.94922 20.0502 7.55922 20.0502 11.9992C20.0502 16.4392 16.4402 20.0492 12.0002 20.0492ZM12.0002 5.04922C8.1702 5.04922 5.0502 8.16922 5.0502 11.9992C5.0502 15.8292 8.1702 18.9492 12.0002 18.9492C15.8302 18.9492 18.9502 15.8292 18.9502 11.9992C18.9502 8.16922 15.8302 5.04922 12.0002 5.04922Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2601 15.0133L11.7901 12.5383C11.5751 12.3233 11.4551 12.0333 11.4551 11.7233V7.48828H12.5551V11.7233L15.0401 14.2333L14.2601 15.0083V15.0133Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7254_14743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeLight);
export default __webpack_public_path__ + "static/media/icon_time_light.7ad37c77.svg";
export { ForwardRef as ReactComponent };